// extracted by mini-css-extract-plugin
export default {"container":"input_container__-9Qo+","searchButton":"input_searchButton__5ZTY-","label":"input_label__bCDDj"};